export { default } from "./TripleHorizontalBars";
